export const enum UserEvent {
  READY = 1000,
  NOT_READY = 1001,
  TALKING = 1003,
  RESERVED = 1004,
  LOG_OUT = 1005,
}
